import {Inject, Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {UserRole} from '../../enums/user-role';
import {ROUTE_REDIRECTS_TOKEN, RouteRedirects} from '../../models/route-redirects';
import {AuthService} from './auth.service';

@Injectable()
export class BackofficeAuthGuard {

    constructor(
        private authService: AuthService,
        private router: Router,

        @Inject(ROUTE_REDIRECTS_TOKEN)
        private routeRedirects: RouteRedirects
    ) {}

    public canActivate(): boolean | UrlTree {
        if (this.authService.userRole === UserRole.TRADER) {
            const url = this.routeRedirects.DASHBOARD_ROUTES[UserRole.TRADER];

            return this.router.parseUrl(url);
        }

        return true;
    }
}
